import React, { useState } from "react";
import {
    PopupTitle,
    PopupContent,
    Form,
    FormItem,
    Input,
    Select,
    Option,
    Checkbox,
    Callout,
    PopupFooter,
    Button,
    Popup,
    Toast,
    Row,
    Col,
    FormButtons
} from "@tv2no/ui-react";
import { parserTypes } from "../../../../../constants";
import { importTaxFile } from "../../../../../api/services/taxYear";

export const NewImportPrompt = ({ taxYear, importFile, onClose, fetchImportStatus }) => {
    const [importOptions, setImportOptions] = useState({
        startFromLine: 2,
        encoding: "UTF-8",
        parser: parserTypes[0].key,
        dryRun: false
    });
    const [busyStartingImport, setBusyStartingImport] = useState(false);

    const handleImportFile = () => {
        setBusyStartingImport(true);
        importTaxFile({
            year: taxYear.year,
            fileName: importFile.name,
            ...importOptions
        })
            .then(() => {
                Toast.success("Startet import av datagrunnlag");
                fetchImportStatus();
                onClose();
            })
            .catch(() => {
                setBusyStartingImport(false);
                Toast.error("En annen import kjører allerede.");
            });
    };

    return (
        <Popup onClose={onClose}>
            <PopupTitle>Importer datagrunnlag</PopupTitle>
            <PopupContent>
                <Form>
                    <Row>
                        <Col span={24}>
                            <FormItem label="Skattefil">
                                <Input value={importFile.name} disabled />
                            </FormItem>
                        </Col>
                        <Col span={24}>
                            <FormItem label="Start fra linjenummer">
                                <Input
                                    value={importOptions.startFromLine}
                                    type="number"
                                    step={1}
                                    min={1}
                                    onChange={(val) =>
                                        setImportOptions({
                                            ...importOptions,
                                            startFromLine: val
                                        })
                                    }
                                />
                            </FormItem>
                        </Col>
                        <Col span={24}>
                            <FormItem label="Encoding">
                                <Select
                                    value={importOptions.encoding}
                                    onChange={(val) =>
                                        setImportOptions({ ...importOptions, encoding: val })
                                    }
                                    placeholder="Velg encoder"
                                >
                                    <Option value="UTF-8">UTF-8</Option>
                                    <Option value="ISO-8859-1">ISO-8859-1</Option>
                                </Select>
                            </FormItem>
                        </Col>
                        <Col span={24}>
                            <FormItem label="Parser">
                                <Select
                                    value={importOptions.parser}
                                    onChange={(val) =>
                                        setImportOptions({ ...importOptions, parser: val })
                                    }
                                    placeholder="Velg parser"
                                >
                                    {parserTypes.map((type) => (
                                        <Option key={type.key} value={type.key}>
                                            {type.name}
                                        </Option>
                                    ))}
                                </Select>
                            </FormItem>
                        </Col>
                        <Col span={24}>
                            <FormItem>
                                <Checkbox
                                    checked={importOptions.dryRun}
                                    onChange={(val) =>
                                        setImportOptions({ ...importOptions, dryRun: val })
                                    }
                                >
                                    Testkjøring
                                </Checkbox>
                            </FormItem>
                        </Col>
                        <Col span={24}>
                            <FormItem>
                                <Callout color="info">
                                    Hvis du huker av "testkjøring" vil importen kjøre som normalt,
                                    men ikke gjøre endringer på søkeindeksen eller laste opp
                                    aggregerte topplister.
                                </Callout>
                            </FormItem>
                        </Col>
                    </Row>
                </Form>
            </PopupContent>
            <PopupFooter>
                <FormButtons>
                    <Button
                        type="submit"
                        icon="check"
                        color="primary"
                        busy={busyStartingImport}
                        disabled={!importOptions.encoding || !importOptions.parser}
                        onClick={handleImportFile}
                    >
                        Start import
                    </Button>
                    <Button onClick={onClose} disabled={busyStartingImport}>
                        Avbryt
                    </Button>
                </FormButtons>
            </PopupFooter>
        </Popup>
    );
};
